module.exports = __webpack_public_path__ + "img/img_title.c8c73dd2.png";